/**
 * Marchio dell'applicazione: il quadrato col glifo, e il nome accanto.
 *
 * Il glifo è lo stesso di `public/favicon.svg` — se si cambia uno va cambiato
 * anche l'altro, altrimenti la scheda del browser e l'intestazione mostrano
 * due segni diversi.
 *
 * Costruito sullo stesso impianto del marchio di FMFlow, l'altra applicazione
 * aziendale, così le due si riconoscono come parenti: stesso quadrato
 * arrotondato, stesso gradiente, glifo bianco a solo tratto. Cambia il
 * disegno, che qui è un calendario con un segno di spunta.
 */

export function Glifo({ dimensione = 18 }: { dimensione?: number }) {
  return (
    <svg
      width={dimensione}
      height={dimensione}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M8 2.5v4M16 2.5v4" />
      <rect x="3.5" y="5.5" width="17" height="15" rx="2.5" />
      <path d="M3.5 10.5h17" />
      <path d="M8.6 15.4l2.5 2.5 4.4-5" />
    </svg>
  );
}

export function Marchio({ dimensione = 18 }: { dimensione?: number }) {
  return (
    <span className="segno-marchio" aria-hidden="true">
      <Glifo dimensione={dimensione} />
    </span>
  );
}
